import { render } from "./modalEdit.vue?vue&type=template&id=4285de2f&ts=true"
import script from "./modalEdit.vue?vue&type=script&lang=ts"
export * from "./modalEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__